import { render, staticRenderFns } from "./PolimixQualityAppraisalForm.vue?vue&type=template&id=5f6a814a&"
import script from "./PolimixQualityAppraisalForm.vue?vue&type=script&lang=js&"
export * from "./PolimixQualityAppraisalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports